var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`${_vm.step}-step`,{tag:"component",attrs:{"email":_vm.email},on:{"email-submitted":_vm.onEmailSubmitted,"password-changed":_vm.onPasswordChanged,"otp-verified":_vm.onOtpVerified}})
}
var staticRenderFns = []

export { render, staticRenderFns }